/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const BulkExternalTransactionsKey = 'bulk-external-transactions-2ralr' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
export const BulkExternalTransactionMainGridKey = `${BulkExternalTransactionsKey}-MainGrid`
